import script from "./CinqueTerreGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./CinqueTerreGuide.vue?vue&type=script&lang=ts&setup=true"

import "./CinqueTerreGuide.vue?vue&type=style&index=0&id=21d50c41&scoped=true&lang=css"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d50c41"]])

export default __exports__